import script from './component-lib.esm8.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isActive ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shouldShow,
      expression: "shouldShow"
    }],
    attrs: {
      "role": "tabpanel",
      "tabIndex": "0",
      "aria-labelledby": _vm.kebabCase(_vm.value) + "-tab"
    }
  }, [_vm._t("default")], 2) : _vm._e();
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-e98ec18c";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };